import React, { useState, useEffect } from "react";
import {
	RootContainer,
	Heading,
	NavContainer,
	SkipButton,
	Logo,
	Title,
	ContentContainer,
	Form,
	ORText,
	TextButton,
	Input,
	RegisterButton,
	LoginButton,
	Divider,
	TelegramLoginButton,
  	SocialLoginWrapper
} from '../AuthStack.style'
import { Spin, Space } from "antd";
import { Navigate, useNavigate } from "react-router-dom";
import { PUBLIC_ROUTE } from "@router/route.constants";
import { useDispatch, useSelector } from "react-redux";
import { api } from "@api";
import { getFingerprintData, localStorage } from "@utils";
import { LOGIN_MODE_SK } from "@constants";
import { IconGoogle,IconTelegram } from "@assets";
import { Alert, LanguageBtn } from "@components";
import { openAlert } from "@redux/app/appSlice";
import { useTranslation } from "react-i18next";
import { useGoogleLogin } from "@react-oauth/google";
import { getSignature } from "@utils";
import { setHasWithdrawAccount } from "@redux/app/appSlice";
import { saveToken, saveUser } from "@redux/auth/authSlice";
import axios from "axios";
import { BURMESE_LANGUAGE_CODE_LK } from '@constants';
import styled from "styled-components";

const GoogleLoginButton = styled.div`
margin: 0px;
width: calc(100% - 40px);
height: 52px;
border-radius: 15px;
display: flex;
gap: 10px;
align-items: center;
justify-content: center;
background-color: #fff;
border: 1px solid ${props => props.theme.primaryColor};
cursor: pointer;
position: relative;

font-size: 14px;
font-weight: bold;
color: ${props => props.theme.primaryColor};

svg {
  width: 24px;
}

.ant-spin {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
`;

const Login = () => {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const isLoggedIn = useSelector((state) => state.auth.token);
	const [loading, setLoading] = useState(false);
	const [googleLoading, setGoogleLoading] = useState(false);
	const [disableButton, setDisableButton] = useState(true);
	const [phoneNumber, setPhoneNumber] = useState();
	const userPreferedLanguage = localStorage.getUserPreferedLanguage();

	const isBurmese = userPreferedLanguage === BURMESE_LANGUAGE_CODE_LK

	  const [telebot, setTeleBot] = useState("");

  useEffect(() => {
  getSettings();
  },[])

	// Disable Login button when phone number input is empty
	useEffect(() => {
		setDisableButton(!phoneNumber);
	}, [phoneNumber]);

	const onFinish = ({ phone }) => {
		if (!loading) {
			setLoading(true);
			getFingerprintData()
				.then(device_info => {
					const data = {
						phone,
						device_info,
					};
					api
						.prelogin(data)
						.then((response) => {
							setLoading(false);
							successCallback(response, data);
						})
						.catch((errorMsg) => {
							setLoading(false);
							showAlert({
								message: errorMsg,
								isError: true,
							});
						});
				})
				.catch(() => { });
		}
	};

	const successCallback = (response, data) => {
		if (response) {
			showAlert({
				message: response?.message,
				successCallback: () => {
					navigate(`/${PUBLIC_ROUTE.OTP_VERIFY}/${LOGIN_MODE_SK}`, {
						state: data,
					});
				},
			});
		} else {
			navigate(`/${PUBLIC_ROUTE.PASSWORD_LOGIN}`, {
				state: data.phone,
			});
		}
	};

	const goToRegister = () => {
		navigate(`/${PUBLIC_ROUTE.REGISTER}`);
	};

	const goToForgotPassword = () => {
		navigate(`/${PUBLIC_ROUTE.FORGOT_PASSWORD}`);
	};

	const skip = () => {
		navigate(`/${PUBLIC_ROUTE.HOME}`);
	};

	const showAlert = (data) => {
		dispatch(openAlert(data));
	};

	const onGoogleLoginSuccess = (credentialResponse) => {
		setGoogleLoading(true);
		const { sub, email } = credentialResponse;
		const signature = getSignature(email, sub);
		const data = {
			email,
			google_user_id: sub,
			signature,
		};
		login(data);
	}

	const login = data => {
		getFingerprintData()
			.then(device_info => {
				const _data = {
					email: data.email,
					device_info,
				};
				api
					.prelogin(_data)
					.then((response) => {
						api
							.login({
								device_info,
								...data,
							})
							.then(({ user }) => {
								setGoogleLoading(false);
								googleLoginSuccessCallback(user);
								showAlert({
									message: t("auth.passwordLoginSuccessMessage"),
									successCallback: () => navigate(`/${PUBLIC_ROUTE.HOME}`),
								});
								getUserPayments();
							})
							.catch((errorMsg) => {
								setGoogleLoading(false);
								showAlert({
									message: errorMsg,
									isError: true,
								});
							});
					})
					.catch((errorMsg) => {
						setGoogleLoading(false);
						showAlert({
							message: errorMsg,
							isError: true,
						});
					});
			})
			.catch(() => {
				setGoogleLoading(false);
			});
	}

	const googleLoginSuccessCallback = ({ token, ...user }) => {
		// save token and user to redux
		dispatch(saveToken(token));
		dispatch(saveUser(user));

		// save token and user to localstorage
		localStorage.setToken(token);
		localStorage.setUser(user);

		// set token to request obj
		api.setSessionToken(token);
	};

	const getUserPayments = () => {
		api
			.getUserPayments()
			.then(({ user_payments }) => {
				dispatch(setHasWithdrawAccount(user_payments.length > 0));
			})
			.catch(() => { });
	};

	const googleLogin = useGoogleLogin({
		onSuccess: async (tokenResponse) => {
			try {
				const userInfo = await axios.get(
					'https://www.googleapis.com/oauth2/v3/userinfo',
					{
						headers: {
							Authorization: `Bearer ${tokenResponse.access_token}`,
						},
					}
				);
				onGoogleLoginSuccess(userInfo.data);
			} catch (err) {
				console.error('Failed to fetch user info:', err);
			}
		},
		onError: () => {
			console.error('Login Failed');
		}
	});

	if (isLoggedIn) {
		return <Navigate to={`/${PUBLIC_ROUTE.HOME}`} />;
	}

	const getSettings = () => {
  api
    .getSettings()
    .then(({ setting }) => {
     setTeleBot(setting?.tele_otp_username);

    })
    .catch((errorMsg) => {
      console.error(errorMsg);
    });
}     

	return (
		<>
			<RootContainer>
				<Heading>
					<NavContainer>
						<LanguageBtn />
						<SkipButton type="secondary" onClick={skip}>
							{t("common.skip")}
						</SkipButton>
					</NavContainer>
					<Logo />

				</Heading>

				<ContentContainer>
					<Title level={2} color="#fff">
						{" "}
						{t("auth.login")}{" "}
					</Title>
					<SocialLoginWrapper>
				<GoogleLoginButton onClick={() => {
					if (!googleLoading) {
						googleLogin();
					}
				}}>
					{googleLoading && <Spin />}
					<IconGoogle />
					{t("auth.googleLogin")}
				</GoogleLoginButton>
				<TelegramLoginButton onClick={() => {
				window.open(`https://t.me/${telebot}`)
				}}>
				<IconTelegram />
				{t('auth.telegramLogin')}
				</TelegramLoginButton>
			</SocialLoginWrapper>

					<Form layout="vertical" onFinish={onFinish} requiredMark={false}>
						<Form.Item
							name="phone"
							label={t("auth.loginPhone")}
							rules={[
								{
									required: true,
									message: "",
								},
								{
									pattern: /^0(1|9)\d{7,9}$/,
									message: t("auth.loginPhoneValidate"),
								},
							]}
						>
							<Input
								autoFocus
								type="number"
								size="large"
								placeholder={t("auth.loginPhonePlaceholder")}
								onChange={(e) => setPhoneNumber(e.target.value)}
							/>
						</Form.Item>

						<Form.Item>
							<LoginButton
								type="primary"
								size="large"
								htmlType="submit"
								loading={loading}
								disabled={disableButton}
							>
								{t("auth.login")}
							</LoginButton>
						</Form.Item>
						<TextButton type="link" onClick={goToForgotPassword}>
							{" "}
							{t("auth.loginForgotPassword")}{" "}
						</TextButton>
					</Form>

				</ContentContainer>
               
				<Space>
					<Divider />
					<ORText isBurmese={isBurmese}> {t("auth.or")} </ORText>
					<Divider />
				</Space>

				<RegisterButton
					type={"default"}
					size="large"
					id="register-btn"
					onClick={goToRegister}
				>
					{t("auth.register")}
				</RegisterButton>
			</RootContainer>
			<Alert />

		</>
	);
};

export default Login;
